import { zod } from "@endya-conformite/ui-kit/src/lya/exports";
import {
  Form,
  InputText,
  useFormConfig,
  FormField,
  FormRow,
  displayErrorToast,
} from "@endya-conformite/ui-kit";
import { useCallback } from "react";
import { GatewayPaymentApi } from "@src/api/payment.api";
import { handleGatewayError } from "@src/api/utils/handleGatewayError";
import {
  ID_FORM_ENTREPRISE,
  ParcoursEntrepriseActions,
} from "../ParcoursEntrepriseActions";
import {
  ParcoursEntrepriseStepComponentProps,
  ParcoursEntrepriseStepEnum,
} from "../ParcoursEntreprise";
import { ParcoursEntrepriseTemplate } from "../ParcoursEntrepriseTemplate";

const schema = zod.object({
  coupon: zod.string().trim(),
});

type CouponType = zod.infer<typeof schema>;

export function EntrepriseCouponPage({
  changeStep,
  addData,
  data,
}: ParcoursEntrepriseStepComponentProps) {
  const formConfig = useFormConfig<typeof schema, CouponType>({
    schema,
    defaultValues: { coupon: data.coupon },
  });

  const handleSubmit = useCallback(
    async ({ coupon }: CouponType) => {
      try {
        await GatewayPaymentApi.assertThatCouponExist(coupon);
        addData({ coupon });
        changeStep(ParcoursEntrepriseStepEnum.PAIEMENT);
      } catch (e) {
        handleGatewayError({
          onResponse: (error) => {
            displayErrorToast(error.response.data.message);
          },
          onUnhandled: (error) => {
            console.error(error);
            displayErrorToast("Une erreur inconnue est survenue");
          },
        })(e);
      }
    },
    [changeStep, addData]
  );

  return (
    <ParcoursEntrepriseTemplate
      title="Code de remise"
      actions={
        <ParcoursEntrepriseActions
          onPrevious={() => changeStep(ParcoursEntrepriseStepEnum.PAIEMENT)}
        >
          Valider
        </ParcoursEntrepriseActions>
      }
    >
      <Form
        id={ID_FORM_ENTREPRISE}
        formConfig={formConfig}
        onSubmit={handleSubmit}
      >
        <FormRow>
          <FormField>
            <InputText<CouponType> name="coupon" label="Code" required />
          </FormField>
        </FormRow>
      </Form>
    </ParcoursEntrepriseTemplate>
  );
}
